import gql from 'graphql-tag';

export const STRIPE_TAX_COUNTRIES = gql`
    query stripeTaxCountries {
        stripeTaxCountries {
            name
            code
            description
        }
    }
`;

export const ISO_COUNTRIES = gql`
    query isoCountries {
        isoCountries {
            name
            alpha2
        }
    }
`;
